module.exports = __webpack_public_path__ + "assets/img/logo-top50.a929b491.png";